var React = require('react');

function Poop (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M480 311v2a70.89 70.89 0 0 1-27.34 56 71.2 71.2 0 0 0-11.66-1H71a71.2 71.2 0 0 0-11.66 1A70.89 70.89 0 0 1 32 313v-2a71 71 0 0 1 71-71h306a71 71 0 0 1 71 71z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M118.05 240H394a63.76 63.76 0 0 0-42-112h-5.88a98.21 98.21 0 0 0 4.36-50.78A94.18 94.18 0 0 0 240.91 1.55 79.78 79.78 0 0 1 176 128h-16a63.76 63.76 0 0 0-42 112zm333.33 129.17l.42-.33A71.12 71.12 0 0 0 441 368H71a70.69 70.69 0 0 0-10.76.84c.14.11.27.23.42.33A71.87 71.87 0 0 0 72 512h368a71.87 71.87 0 0 0 11.36-142.86z","className":"fa-primary","key":2})]);
}

Poop.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Poop;

Poop.default = Poop;
